export const normalizeText = (text: string): string =>
  text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase()
    .trim()

export const simpleTextCompareFn = (str1: string, str2: string) => str1.localeCompare(str2)
